import { useConfigContext } from "@/app";
import { Payments } from "@/constants";
import { createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import { ErPayment } from "@/types/Api/Market/Order/myOrderDetail";
import { OrderDetail } from "@/types/Api/Order";
import { useToggle } from "ahooks";
import { Image, ImageViewer } from "antd-mobile";
import { SystemQRcodeOutline } from "antd-mobile-icons";
import { CopyIcon } from "../CopyIcon";
import "./index.scss";
import { useBankStore } from "@/stores/banks";
import { areaList } from "@vant/area-data";
interface Info extends ErPayment {
  alipayAccount?: string;
  receiptCode?: string;
  wxRealname?: string;
  digitalAddress?: string;
  remark?: string;
}
interface Order extends OrderDetail {
  remark?: string;
  pay_username?: string;
}
export interface PaymentInfoProps extends ComponentBase.Component {
  payment: Payments;
  info?: Info;
  show: boolean;
  isProfession?: number;
  order?: Order;
}
const defaultInfo = {
  id: 0,
  province: "0",
  city: "0",
  realName: "***",
  alipayAccount: "***",
  wxRealname: "***",
  bankBranch: "*** ***",
  bankNo: "**** **** **** ****",
  bankId: "***",
  remark: '',
  logoImg: "",
  digitalAddress: ""
};
export const PaymentInfo = ({
  payment,
  info = defaultInfo,
  show,
  isProfession = 0,
  order
}: PaymentInfoProps) => {
  const b = createBEM("payment-info");
  const [bankMap] = useBankStore(state => [state.bankMap]);
  const {
    province_list,
    city_list
  } = areaList; // 省市区
  if (!show) info = defaultInfo;
  const {
    getSourcePath
  } = useConfigContext();
  const [visible, {
    toggle: toggleVisible
  }] = useToggle();
  {/* 超级商家隐藏其他买家付款信息  只展示备注 */}
  if (isProfession) {
    return <div className={b()}>
        <div className={b("item")}>
          <div className={b("label")}>买家备注</div>
          <div className={b("value")}>{order?.remark || '无'}</div>
        </div>
        <div className={b("item")}>
          <div className={b("label")}>买家姓名</div>
          <div className={b("value")}>{order?.pay_username || ''}</div>
        </div>
      </div>;
  }
  if (payment === Payments.BANK) {
    return <div className={b()}>
        <div className={b("item")}>
          <div className={b("label")}>银行名称</div>
          <div className={b("value")}>{info && info.bankId ? bankMap[(info.bankId as any)] : info?.bankId || ''}</div>
        </div>
        <div className={b("item")}>
          <div className={b("label")}>开户所在地</div>
          <div className={b("value")}>{info && info.city ? `${province_list[info.province || ''] || ''} ${city_list[info.city || ''] || ''}` : info?.city || ''}</div>
        </div>
        <div className={b("item")}>
          <div className={b("label")}>开户支行</div>
          <div className={b("value")}>{info?.bankBranch || ''}</div>
        </div>
        <div className={b("item")}>
          <div className={b("label")}>姓名</div>
          <div className={b("value")}>{info?.realName || ''}</div>
          {show && <CopyIcon text={info?.realName || ""} />}
        </div>
        <div className={b("item")}>
          <div className={b("label")}>银行卡号</div>
          <div className={b("value")}>{info?.bankNo || ''}</div>
          {show && <CopyIcon text={String(info?.bankNo || '')} />}
        </div>
      </div>;
  }
  if (payment === Payments.ALI) {
    return <div className={b(["QRCode"])}>
        <div className={b("info")}>
          <div className={b("item")}>
            <div className={b("label")}>支付宝账号</div>
            <div className={b("value")}>{info?.alipayAccount}</div>
            {show && <CopyIcon text={info?.alipayAccount || ""} />}
          </div>
          <div className={b("item")}>
            <div className={b("label")}>姓名</div>
            <div className={b("value")}>{info?.realName}</div>
            {show && <CopyIcon text={info?.realName || ""} />}
          </div>
        </div>
        {show ? <Image fit="cover" className={b("qrcode")} src={getSourcePath(info.receiptCode)} alt="二维码" onClick={toggleVisible} /> : <SystemQRcodeOutline className={b("qrcode")} />}
        <ImageViewer image={getSourcePath(info.receiptCode)} visible={visible} onClose={toggleVisible} />
      </div>;
  }
  if (payment === Payments.WE_CHAT || payment === Payments.WX_GROUP) {
    return <div className={b(["QRCode"])}>
        <div className={b("info")}>
          <div className={b("item")}>
            <div className={b("label")}>微信账号</div>
            <div className={b("value")}>{info?.wxRealname}</div>
            {show && <CopyIcon text={info?.wxRealname || ""} />}
          </div>
          <div className={b("item")}>
            <div className={b("label")}>姓名</div>
            <div className={b("value")}>{info?.realName}</div>
            {show && <CopyIcon text={info?.realName || ""} />}
          </div>
        </div>
        {show ? <Image fit="fill" className={b("qrcode")} src={getSourcePath(info.receiptCode)} alt="二维码" onClick={toggleVisible} /> : <SystemQRcodeOutline className={b("qrcode")} />}
        <ImageViewer image={getSourcePath(info.receiptCode)} visible={visible} onClose={toggleVisible} />
      </div>;
  }
  if (payment === Payments.DIGITAL_RMB) {
    return <div className={b()}>
          <div className={b("item")}>
            <div className={b("label")}>地址</div>
            <div className={b("value")}>{info?.digitalAddress}</div>
            {show && <CopyIcon text={info?.digitalAddress || ""} />}
          </div>
          <div className={b("item")}>
            <div className={b("label")}>姓名</div>
            <div className={b("value")}>{info?.realName}</div>
            {show && <CopyIcon text={info?.realName || ""} />}
          </div>
        
      </div>;
  }
  return <div data-sentry-component="PaymentInfo" data-sentry-source-file="index.tsx"></div>;
};